module.exports = __webpack_public_path__ + "static/img/standard-quality-control-concept-m.6a90c360.jpg";